import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCheckedDocumentsCount = createSelector(
  [(store: RootState) => store.documentsSignerList.documents],
  (documents) => documents.filter(({ checked }) => checked).length
);
